import {GameStateEnums} from '../../../../../shared/GameEnums'
import {UIGameMechanic} from '../UIGameEventController'
import {UIGameManager} from '../UIGameManager'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {CityImprovementTypes, MechanicCityImprovementsPlayerState} from '@colonist/game-states'
import {EnumUtils} from '@colonist/utils'
import {Sound} from '../../Sound'
import {LEVEL_REQUIRED_TO_UNLOCK_SPECIAL_ABILITY, MINIMUM_LEVEL_REQUIRED_FOR_METROPOLIS} from '@colonist/game-state-types'
import {UIGameAddAchievementEvent} from '@colonist/ui-game'

export class UIGameCityImprovementAchievementController implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private readonly myCityImprovementsState: MechanicCityImprovementsPlayerState
    private myOldCityImprovementLevels: Map<CityImprovementTypes, number>

    constructor(uiGameManager: UIGameManager, myCityImprovementsState: MechanicCityImprovementsPlayerState) {
        this.uiGameManager = uiGameManager
        this.uiGameManager.eventController.registerUIGameMechanic(this)
        this.myCityImprovementsState = myCityImprovementsState
        this.initMyOldCityImprovementLevels()
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.CityImprovementStateUpdated: this.checkIfPlayerUnlockedSpecialAbility(); break
            default: break
        }
    }

    private initMyOldCityImprovementLevels() {
        this.myOldCityImprovementLevels = new Map<CityImprovementTypes, number>([
            [CityImprovementTypes.Politics, this.myCityImprovementsState[CityImprovementTypes.Politics]?.level ?? 0],
            [CityImprovementTypes.Science, this.myCityImprovementsState[CityImprovementTypes.Science]?.level ?? 0],
            [CityImprovementTypes.Trade, this.myCityImprovementsState[CityImprovementTypes.Trade]?.level ?? 0],
        ])
    }

    private checkIfPlayerUnlockedSpecialAbility() {
        const unlockedCityImprovementType = this.didPlayerUnlockSpecialAbility()
        if(unlockedCityImprovementType == undefined) return
        this.unlockedSpecialAbility(unlockedCityImprovementType)
    }

    private didPlayerUnlockSpecialAbility(): CityImprovementTypes | undefined {
        let unlockedCityImprovementType: CityImprovementTypes | undefined
        EnumUtils.iterateEnum(CityImprovementTypes, (type: CityImprovementTypes) => {
            const previousLevel = this.myOldCityImprovementLevels.get(type)
            const newLevel = this.myCityImprovementsState[type]?.level
            if(newLevel == undefined || previousLevel == undefined) return
            if(newLevel != LEVEL_REQUIRED_TO_UNLOCK_SPECIAL_ABILITY) return
            if(previousLevel >= newLevel) return

            this.playCityImprovementSound(newLevel)
            this.myOldCityImprovementLevels.set(type, newLevel)
            unlockedCityImprovementType = type
        })
        return unlockedCityImprovementType
    }

    private unlockedSpecialAbility(cityImprovementType: CityImprovementTypes) {
        switch(cityImprovementType) {
            case CityImprovementTypes.Politics: this.unlockedFortress(); break
            case CityImprovementTypes.Science: this.unlockedAqueduct(); break
            case CityImprovementTypes.Trade: this.unlockedTradingHouse(); break
        }
    }

    private unlockedFortress() {
        this.broadCastPlayerReceivedAchievement('Fortress')
    }

    private unlockedAqueduct() {
        this.broadCastPlayerReceivedAchievement('Aqueduct')
    }

    private unlockedTradingHouse() {
        this.broadCastPlayerReceivedAchievement('TradingHouse')
    }

    private broadCastPlayerReceivedAchievement(achievementType: 'TradingHouse' | 'Aqueduct' | 'Fortress') {
        const achievement: UIGameAddAchievementEvent = {
            achievementOwnerNew: this.uiGameManager.gameController.myColor,
            achievementType: achievementType,
        }

        this.uiGameManager.eventController.sendEvent(achievement, UIGameEventEnums.PlayerReceivedAchievement)
    }

    private playCityImprovementSound(newCityLevel: number) {
        if(this.uiGameManager.gameController.isReplay) return

        if(newCityLevel == MINIMUM_LEVEL_REQUIRED_FOR_METROPOLIS) return
        if(newCityLevel == LEVEL_REQUIRED_TO_UNLOCK_SPECIAL_ABILITY) return Sound.playSound(Sound.SoundType.AchievementCKProgress)
        Sound.playSound(Sound.SoundType.CityImprovement)
    }
}
